import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlassChart,
  faMessage,
  faGift,
  faPenNib,
  faRobot,
  faGlobe,
  faGaugeHigh,
  faHandshakeAngle,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faMagnifyingGlassChart,
    title: "Discovery & Research",
    description:
      "Clarify your audience, map the journey, and identify the real problems worth solving before we design or build.",
    tags: ["ICP", "User Journeys", "Insights"],
  },
  {
    icon: faMessage,
    title: "Positioning & Messaging",
    description:
      "Turn what you do into a simple, repeatable story that resonates on your website, ads, and sales calls.",
    tags: ["Story", "Value Props", "Clarity"],
  },
  {
    icon: faGift,
    title: "Offers & Funnels",
    description:
      "Define lead magnets, trial paths, and service packages that make it easy for the right people to say yes.",
    tags: ["Packages", "Funnels", "Conversion"],
  },
  {
    icon: faPenNib,
    title: "Creative & Copy",
    description:
      "Pages, visuals, and copy that feel on-brand, load fast, and guide visitors towards the next best step.",
    tags: ["UX", "Copywriting", "Visuals"],
  },
  {
    icon: faRobot,
    title: "Automation & CRM",
    description:
      "Set up forms, routing, and nurture flows so every lead is captured, followed up, and tracked properly.",
    tags: ["Workflows", "CRM", "Playbooks"],
  },
  {
    icon: faGlobe,
    title: "Acquisition Channels",
    description:
      "Choose and prioritize the channels that make sense for your stage—search, paid, social, or referral loops.",
    tags: ["SEO / SEM", "Paid", "Organic"],
  },
  {
    icon: faGaugeHigh,
    title: "Analytics & Reporting",
    description:
      "Clean tracking, dashboards, and simple metrics so you know what’s working and what to fix next.",
    tags: ["GA4", "Dashboards", "Attribution"],
  },
  {
    icon: faHandshakeAngle,
    title: "Ongoing Support",
    description:
      "A partner you can message when things break, priorities change, or you want to test a new idea quickly.",
    tags: ["Sprints", "Retainers", "Support"],
  },
];

const Strategies = () => {
  return (
    <section className="strat2" aria-label="How we structure growth work">
      <div className="strat2-wrap">
        {/* Header */}
        <header className="strat2-head">
          <p className="kicker">How we think</p>
          <h2>Building systems, not one-off campaigns.</h2>
          <p className="sub">
            Each engagement taps into this same framework—strategy, creative, and operations
            working together so your website and marketing keep improving month after month.
          </p>
        </header>

        {/* Grid */}
        <div className="strat2-grid" role="list">
          {strategyItems.map((item, i) => (
            <article className="strat2-card" role="listitem" key={item.title}>
              <div className="card-top">
                <div className="icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <span className="num">{String(i + 1).padStart(2, "0")}</span>
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>

              <div className="tags">
                {item.tags.map((t) => (
                  <span className="tag" key={t}>
                    {t}
                  </span>
                ))}
              </div>

              <div className="cta" aria-hidden="true">
                See how this shows up in projects →
              </div>
            </article>
          ))}
        </div>

        {/* Footnote strip */}
        <div className="strat2-strip">
          <span>
            Strategy first • Clear priorities • Small, repeatable wins that compound over time
          </span>
        </div>
      </div>
    </section>
  );
};

export default Strategies;
